// src/redux/carLocationApi.js
import { apiSlice } from "./apiSlice";

export const carLocationApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 차고지 상세조회
        getCarLocationById: build.query({
            query: (carLocationId) => ({
                url: `/api/user/car_location/v1/${carLocationId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 차고지 수정
        putCarLocation: build.mutation({
            query: ({ carLocationId, body }) => ({
                url: `/api/user/car_location/v1/${carLocationId}`,
                method: "put",
                headers: { token: true },
                data: body,
            }),
        }),
        // 차고지 삭제
        deleteCarLocation: build.mutation({
            query: (carLocationId) => ({
                url: `/api/user/car_location/v1/${carLocationId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
        // 차고지 리스트 조회
        getCarLocationList: build.query({
            query: (params) => ({
                url: "/api/user/car_location/v1",
                method: "get",
                headers: { token: true },
                params,
            }),
        }),
        // 차고지 등록
        postCarLocation: build.mutation({
            query: (body) => ({
                url: "/api/user/car_location/v1",
                method: "post",
                headers: { token: true },
                data: body,
            }),
        }),
    }),
});

export const {
    useGetCarLocationByIdQuery,
    usePutCarLocationMutation,
    useDeleteCarLocationMutation,
    useGetCarLocationListQuery,
    usePostCarLocationMutation,
} = carLocationApi;
